/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AccessLevelEnum {
  CREHANA_CORE = 'CREHANA_CORE',
  CREHANA_CORE_ELEVATE = 'CREHANA_CORE_ELEVATE',
  CREHANA_ELEVATE = 'CREHANA_ELEVATE',
}

export enum ActionType {
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
}

export enum AgentTypeEnum {
  AGENT_TYPE_EXTERNAL = 'AGENT_TYPE_EXTERNAL',
  AGENT_TYPE_INTERNAL = 'AGENT_TYPE_INTERNAL',
  AGENT_TYPE_OTHER = 'AGENT_TYPE_OTHER',
}

export enum AnalyticsUserStatusEnum {
  STATUS_USERS_ACTIVE = 'STATUS_USERS_ACTIVE',
  STATUS_USERS_DELETE = 'STATUS_USERS_DELETE',
  STATUS_USERS_INACTIVE = 'STATUS_USERS_INACTIVE',
  STATUS_USERS_PENDING = 'STATUS_USERS_PENDING',
}

export enum ApprovalRequirementStudioEnum {
  FINAL_PROJECT = 'FINAL_PROJECT',
  NOT_REQUIREMENT = 'NOT_REQUIREMENT',
  QUIZ_EVALUATION = 'QUIZ_EVALUATION',
}

export enum AutomationConditionalTypesEnum {
  AC_BEGINS_WITH = 'AC_BEGINS_WITH',
  AC_CONTAINS = 'AC_CONTAINS',
  AC_ENDS_WITH = 'AC_ENDS_WITH',
  AC_EQUAL_TO = 'AC_EQUAL_TO',
  AC_NOT_CONTAINS = 'AC_NOT_CONTAINS',
  AC_NOT_EQUAL_TO = 'AC_NOT_EQUAL_TO',
}

export enum AutomationRuleFrequencyEnum {
  DAILY = 'DAILY',
}

export enum AutomationRuleTypeEnum {
  AUTOMATION_RULE_TYPE_COURSE = 'AUTOMATION_RULE_TYPE_COURSE',
  AUTOMATION_RULE_TYPE_ONBOARDING = 'AUTOMATION_RULE_TYPE_ONBOARDING',
  AUTOMATION_RULE_TYPE_SKILL_XP = 'AUTOMATION_RULE_TYPE_SKILL_XP',
}

export enum AutomationUserTypeEnum {
  ADMINISTRATOR = 'ADMINISTRATOR',
  USER = 'USER',
}

export enum BucketsEnum {
  CENTRALIZED_PRIVATE_B2B = 'CENTRALIZED_PRIVATE_B2B',
  PRIVATE_AUDITLOG_REPORTS = 'PRIVATE_AUDITLOG_REPORTS',
  PRIVATE_B2B = 'PRIVATE_B2B',
  PRIVATE_CERTIFICATE_SIGNATURES = 'PRIVATE_CERTIFICATE_SIGNATURES',
  PRIVATE_COURSE_ATTACHMENT = 'PRIVATE_COURSE_ATTACHMENT',
  PRIVATE_INTERCOMMS = 'PRIVATE_INTERCOMMS',
  PRIVATE_TALENT_GENERAL = 'PRIVATE_TALENT_GENERAL',
  PRIVATE_USER = 'PRIVATE_USER',
  PRIVATE_VIDEO_SOURCE = 'PRIVATE_VIDEO_SOURCE',
  PUBLIC_CATALOG = 'PUBLIC_CATALOG',
  PUBLIC_DEV = 'PUBLIC_DEV',
  PUBLIC_LESSON = 'PUBLIC_LESSON',
  PUBLIC_SUBTITLE = 'PUBLIC_SUBTITLE',
  PUBLIC_TRAILER = 'PUBLIC_TRAILER',
  PUBLIC_USER = 'PUBLIC_USER',
  PUBLIC_VIDEO = 'PUBLIC_VIDEO',
}

export enum CentralizedUserOrganizationRoleEnum {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  SUBADMIN = 'SUBADMIN',
}

export enum CentralizedUserOrganizationStatusEnum {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export enum CopyCourseTypeEnum {
  COPY_COURSE_TYPE_ALL = 'COPY_COURSE_TYPE_ALL',
  COPY_COURSE_TYPE_INFORMATION = 'COPY_COURSE_TYPE_INFORMATION',
  COPY_COURSE_TYPE_MODULE = 'COPY_COURSE_TYPE_MODULE',
}

export enum CourseOrderByEnum {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
}

export enum CourseTypeEnum {
  B2B = 'B2B',
  B2B_CLASSROOMS = 'B2B_CLASSROOMS',
  CREHANA_COURSE_TYPE = 'CREHANA_COURSE_TYPE',
  DEGREE = 'DEGREE',
  EXTERNAL_COURSE_TYPE = 'EXTERNAL_COURSE_TYPE',
  FREE = 'FREE',
  FREEMIUM = 'FREEMIUM',
  HIDDEN = 'HIDDEN',
  MEMBERSHIP = 'MEMBERSHIP',
  OWN_COURSE_TYPE = 'OWN_COURSE_TYPE',
  PAID = 'PAID',
  PARTNER = 'PARTNER',
  ROCKSTAR = 'ROCKSTAR',
  TEMPORAL_ACCESS = 'TEMPORAL_ACCESS',
}

export enum CurrencyPointStatusEnum {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export enum CustomFieldMandatoryEnum {
  CREATION = 'CREATION',
  PROFILE = 'PROFILE',
}

export enum CustomFieldTypeEnum {
  DATE = 'DATE',
  MULTIPLE = 'MULTIPLE',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}

export enum DataTypeEnum {
  DATE = 'DATE',
  LIST = 'LIST',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}

export enum DownloadDocumentTypeEnum {
  DOWNLOAD_DOCUMENT_TYPE_COURSE = 'DOWNLOAD_DOCUMENT_TYPE_COURSE',
  DOWNLOAD_DOCUMENT_TYPE_DC3 = 'DOWNLOAD_DOCUMENT_TYPE_DC3',
  DOWNLOAD_DOCUMENT_TYPE_DC4 = 'DOWNLOAD_DOCUMENT_TYPE_DC4',
}

export enum EmailContentTypeEnum {
  CONTENT_TYPE_COURSE = 'CONTENT_TYPE_COURSE',
  CONTENT_TYPE_LIVE_SESSION = 'CONTENT_TYPE_LIVE_SESSION',
  CONTENT_TYPE_TRACK = 'CONTENT_TYPE_TRACK',
}

export enum EmailSectionEnum {
  HRIS_GENERAL_SECTION = 'HRIS_GENERAL_SECTION',
  SECTION_COURSE_STATISTICS = 'SECTION_COURSE_STATISTICS',
  SECTION_LIVE_SESSION = 'SECTION_LIVE_SESSION',
  SECTION_TRACK_PANEL = 'SECTION_TRACK_PANEL',
  SECTION_USER_PANEL = 'SECTION_USER_PANEL',
}

export enum EmailTagEnum {
  CONTENT_NAME = 'CONTENT_NAME',
  FIRST_NAME = 'FIRST_NAME',
  FULL_NAME = 'FULL_NAME',
  LAST_LOGIN = 'LAST_LOGIN',
  LAST_NAME = 'LAST_NAME',
}

export enum EnterpriseEnum {
  ATS = 'ATS',
  LEARNING = 'LEARNING',
  TALENT = 'TALENT',
  WORKBEAT = 'WORKBEAT',
}

export enum EventTypeEnum {
  ACHIEVEMENT = 'ACHIEVEMENT',
  EVENT = 'EVENT',
}

export enum FeatureFlagCategoryEnum {
  CATEGORY_EXPERIMENTAL = 'CATEGORY_EXPERIMENTAL',
  CATEGORY_FEATURE = 'CATEGORY_FEATURE',
}

export enum FileFormatEnum {
  CSV_FORMAT = 'CSV_FORMAT',
  XLSX_FORMAT = 'XLSX_FORMAT',
}

export enum FileStorageStatusEnum {
  STATUS_COMPLETED = 'STATUS_COMPLETED',
  STATUS_DELETED = 'STATUS_DELETED',
  STATUS_FAILED = 'STATUS_FAILED',
  STATUS_INITIALIZED = 'STATUS_INITIALIZED',
  STATUS_PENDING = 'STATUS_PENDING',
}

export enum FileUploadStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  UPLOADING = 'UPLOADING',
}

export enum FreeTrialStatusEnum {
  STATUS_ENDED = 'STATUS_ENDED',
  STATUS_INITIALIZING = 'STATUS_INITIALIZING',
  STATUS_NOT_STARTED = 'STATUS_NOT_STARTED',
  STATUS_STARTED = 'STATUS_STARTED',
}

export enum GeneralSheetsEnum {
  ACTIVITY_SHEET = 'ACTIVITY_SHEET',
  COURSE_SHEET = 'COURSE_SHEET',
  GENERAL_SHEET = 'GENERAL_SHEET',
  PERFORMANCE_SHEET = 'PERFORMANCE_SHEET',
}

export enum LiveSessionUserEngagementMethodEnum {
  MANUAL = 'MANUAL',
  MASSIVE = 'MASSIVE',
}

export enum LiveSessionUserEngagementStateEnum {
  FINISHED = 'FINISHED',
  PROCESSING = 'PROCESSING',
  SUBMITTED = 'SUBMITTED',
  VALIDATED = 'VALIDATED',
}

export enum LiveSessionUserTrackerTypeEnum {
  ASSIGNMENT = 'ASSIGNMENT',
  ATTENDANCE = 'ATTENDANCE',
}

export enum OrderDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

/**
 * Enum representing user attributes available for ordering the user list.
 */
export enum OrderUserAttributeEnum {
  AREA = 'AREA',
  EMAIL = 'EMAIL',
  FULL_NAME = 'FULL_NAME',
  POSITION = 'POSITION',
}

export enum OrganizationAreaFilterBy {
  AZ = 'AZ',
  CREATED_AT = 'CREATED_AT',
  ZA = 'ZA',
}

export enum OrganizationReportGenerationFrequencyEnum {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export enum PeriodEnum {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export enum QuizStatusEnum {
  APPROVED = 'APPROVED',
  CERTIFICATED = 'CERTIFICATED',
  DISAPPROVED = 'DISAPPROVED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_COMPLETED = 'NOT_COMPLETED',
  NOT_INITIALIZED = 'NOT_INITIALIZED',
}

export enum ReportEnrollmentOrderByEnum {
  COURSE_TITLE = 'COURSE_TITLE',
  ENROLLMENT_AT = 'ENROLLMENT_AT',
}

export enum ReportEnrollmentSearchFilterEnum {
  ENROLLMENT_SEARCH_FILTER_ACTIVE = 'ENROLLMENT_SEARCH_FILTER_ACTIVE',
  ENROLLMENT_SEARCH_FILTER_ALL = 'ENROLLMENT_SEARCH_FILTER_ALL',
  ENROLLMENT_SEARCH_FILTER_COMPLETED = 'ENROLLMENT_SEARCH_FILTER_COMPLETED',
  ENROLLMENT_SEARCH_FILTER_INACTIVE = 'ENROLLMENT_SEARCH_FILTER_INACTIVE',
  ENROLLMENT_SEARCH_FILTER_IN_PROGRESS = 'ENROLLMENT_SEARCH_FILTER_IN_PROGRESS',
  ENROLLMENT_SEARCH_FILTER_NOT_STARTED = 'ENROLLMENT_SEARCH_FILTER_NOT_STARTED',
}

export enum ReportEnrollmentTypeEnum {
  B2B = 'B2B',
  DEGREE = 'DEGREE',
  FREE = 'FREE',
  FREEMIUM = 'FREEMIUM',
  FREE_MEMBERSHIP = 'FREE_MEMBERSHIP',
  GIFT_CARD = 'GIFT_CARD',
  MEMBERSHIP = 'MEMBERSHIP',
  MENTOR = 'MENTOR',
  MIGRATE = 'MIGRATE',
  PAID = 'PAID',
  PREVIEW_TRIAL = 'PREVIEW_TRIAL',
  PROFESSOR = 'PROFESSOR',
  STAFF = 'STAFF',
  TEMPORAL_ACCESS = 'TEMPORAL_ACCESS',
}

export enum ReportGenerationTypeEnum {
  FROM_TEMPLATE = 'FROM_TEMPLATE',
  ON_DEMAND = 'ON_DEMAND',
  SCHEDULED = 'SCHEDULED',
}

export enum ReportTeamOrderByEnum {
  ASSIGNED_DATE = 'ASSIGNED_DATE',
  COMPLETED_DATE = 'COMPLETED_DATE',
  IS_COMPLETED = 'IS_COMPLETED',
  ROUTE_NAME = 'ROUTE_NAME',
  ROUTE_PROGRESS = 'ROUTE_PROGRESS',
}

export enum ReportsEnum {
  REPORT_ADHOC_POSADAS_QUIZ_AND_GENERAL = 'REPORT_ADHOC_POSADAS_QUIZ_AND_GENERAL',
  REPORT_B2B_COURSES = 'REPORT_B2B_COURSES',
  REPORT_B2B_ELEVATE_COURSES = 'REPORT_B2B_ELEVATE_COURSES',
  REPORT_B2B_GENERAL = 'REPORT_B2B_GENERAL',
  REPORT_B2B_LEADERS = 'REPORT_B2B_LEADERS',
  REPORT_B2B_LIVE_SESSIONS = 'REPORT_B2B_LIVE_SESSIONS',
  REPORT_B2B_NOT_STUDYING_USERS = 'REPORT_B2B_NOT_STUDYING_USERS',
  REPORT_B2B_PENDING_USERS = 'REPORT_B2B_PENDING_USERS',
  REPORT_B2B_QUIZZ_RESPONSES_BY_CLASSES = 'REPORT_B2B_QUIZZ_RESPONSES_BY_CLASSES',
  REPORT_B2B_RESULT_QUIZZ_BY_CLASSES = 'REPORT_B2B_RESULT_QUIZZ_BY_CLASSES',
  REPORT_B2B_TRACKS = 'REPORT_B2B_TRACKS',
  REPORT_B2B_USERS = 'REPORT_B2B_USERS',
  REPORT_CENTRALIZED_USERS = 'REPORT_CENTRALIZED_USERS',
}

export enum ResourceTypeEnum {
  FILE = 'FILE',
  URL = 'URL',
}

/**
 * Enum that defines the type of attribute used in user segmentation conditionals.
 */
export enum SegmentAttributeTypeEnum {
  ALPHABETIC = 'ALPHABETIC',
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  DATE = 'DATE',
  NUMERIC = 'NUMERIC',
}

/**
 * Enum that defines the global modifier for user segmentation groups.
 */
export enum SegmentGlobalModifier {
  AND = 'AND',
  OR = 'OR',
}

/**
 * Available attributes for alphabetic segmentation rules.
 */
export enum SegmentRuleAlphabeticAttributeLiteralEnum {
  BRANCH = 'BRANCH',
  COUNTRY = 'COUNTRY',
  GENDER = 'GENDER',
  POSITION = 'POSITION',
  POSITION_CATEGORY = 'POSITION_CATEGORY',
  ROLE = 'ROLE',
}

/**
 * Condition for alphabetic rules using multiple choice values.
 */
export enum SegmentRuleAlphabeticConditionMultipleEnum {
  EQUAL_TO_OPTION = 'EQUAL_TO_OPTION',
}

/**
 * Conditions for alphabetic rules using single values.
 */
export enum SegmentRuleAlphabeticConditionSingleEnum {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  ENDS_WITH = 'ENDS_WITH',
  EQUAL_TO_STRING = 'EQUAL_TO_STRING',
  STARTS_WITH = 'STARTS_WITH',
}

export enum SegmentRuleDateAttributeLiteralEnum {
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  DATE_OF_JOINING = 'DATE_OF_JOINING',
}

export enum SegmentRuleDateConditionRangeEnum {
  RANGE = 'RANGE',
}

export enum SegmentRuleDateConditionSingleEnum {
  EQUAL_TO = 'EQUAL_TO',
}

/**
 * Numeric condition that defines a range.
 */
export enum SegmentRuleNumericConditionRangeEnum {
  RANGE = 'RANGE',
}

/**
 * Conditions for numeric rules using single values.
 */
export enum SegmentRuleNumericConditionSingleEnum {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  ENDS_WITH = 'ENDS_WITH',
  EQUAL_TO = 'EQUAL_TO',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  STARTS_WITH = 'STARTS_WITH',
}

/**
 * Enum that defines the type of user segmentation.
 */
export enum SegmentTypeEnum {
  DYNAMIC = 'DYNAMIC',
  STATIC = 'STATIC',
}

export enum SessionTimeLineEnum {
  FOR_START = 'FOR_START',
  FUTURE = 'FUTURE',
  LIVE = 'LIVE',
  PAST = 'PAST',
}

export enum SessionTimeZoneEnum {
  TIME_ZONE_ES_AR = 'TIME_ZONE_ES_AR',
  TIME_ZONE_ES_CL = 'TIME_ZONE_ES_CL',
  TIME_ZONE_ES_CO = 'TIME_ZONE_ES_CO',
  TIME_ZONE_ES_ES = 'TIME_ZONE_ES_ES',
  TIME_ZONE_ES_MX = 'TIME_ZONE_ES_MX',
  TIME_ZONE_ES_PE = 'TIME_ZONE_ES_PE',
  TIME_ZONE_PT_BR = 'TIME_ZONE_PT_BR',
}

export enum SessionTypeEnum {
  ONLINE = 'ONLINE',
  PRESENCE = 'PRESENCE',
}

export enum StepEnum {
  STEP_CONTENT = 'STEP_CONTENT',
  STEP_INFORMATION = 'STEP_INFORMATION',
  STEP_REQUIREMENTS = 'STEP_REQUIREMENTS',
  STEP_SUMMARY = 'STEP_SUMMARY',
}

export enum StudioCourseConfigStateEnum {
  HIDDEN = 'HIDDEN',
}

export enum TaskTypesEnum {
  TEAMS_SYNC = 'TEAMS_SYNC',
}

export enum TemplateOrientationEnum {
  ORIENTATION_HORIZONTAL_TEMPLATE = 'ORIENTATION_HORIZONTAL_TEMPLATE',
  ORIENTATION_VERTICAL_TEMPLATE = 'ORIENTATION_VERTICAL_TEMPLATE',
}

export enum TemplateRegulationTypeEnum {
  TEMPLATE_REGULATION_TYPE_DC3 = 'TEMPLATE_REGULATION_TYPE_DC3',
  TEMPLATE_REGULATION_TYPE_OWN = 'TEMPLATE_REGULATION_TYPE_OWN',
}

export enum TemplateStatusEnum {
  TEMPLATE_STATUS_COMPLETED = 'TEMPLATE_STATUS_COMPLETED',
  TEMPLATE_STATUS_DELETED = 'TEMPLATE_STATUS_DELETED',
  TEMPLATE_STATUS_DRAFT = 'TEMPLATE_STATUS_DRAFT',
}

export enum TemplateTypeEnum {
  TEMPLATE_TYPE_COURSE = 'TEMPLATE_TYPE_COURSE',
  TEMPLATE_TYPE_COURSE_ELEVATE = 'TEMPLATE_TYPE_COURSE_ELEVATE',
  TEMPLATE_TYPE_PARTICIPATION_CERTIFICATE = 'TEMPLATE_TYPE_PARTICIPATION_CERTIFICATE',
  TEMPLATE_TYPE_TRACK = 'TEMPLATE_TYPE_TRACK',
  TEMPLATE_TYPE_TRACK_ACADEMY = 'TEMPLATE_TYPE_TRACK_ACADEMY',
}

export enum TrackVersionEnum {
  VERSION_1 = 'VERSION_1',
  VERSION_2 = 'VERSION_2',
}

export enum UserOrganizationRoleEnum {
  ADMIN = 'ADMIN',
  LEADER = 'LEADER',
  MEMBER = 'MEMBER',
  SUBADMIN = 'SUBADMIN',
}

export enum UserOrganizationStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export enum UserRoleEnum {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MEMBERS = 'ROLE_MEMBERS',
}

export enum ValidationEmailAction {
  ACTION_ASSIGNMENT = 'ACTION_ASSIGNMENT',
  ACTION_UNASSIGNMENT = 'ACTION_UNASSIGNMENT',
}

export enum VisibilityLevelType {
  HIDDEN = 'HIDDEN',
  PUBLISHED = 'PUBLISHED',
}

export interface AddUsersInTeamOrganizationInput {
  organization_id?: number | null;
  organization_team_id: string;
  user_ids?: number[] | null;
  user_organization_id?: number | null;
  emails?: string[] | null;
  email?: string | null;
}

export interface AssignCourseByExcelInput {
  organization_id?: number | null;
  success_file_id: number;
  course_id: number;
}

export interface AssignCourseToMultipleUserInput {
  organization_id?: number | null;
  course_id: number;
  user_list_ids: number[];
  centralized_user_list_ids?: number[] | null;
  send_email_to_all_selected_users?: boolean | null;
}

export interface AssignOrganizationUserFileQueryInput {
  organization_id?: number | null;
  assign_organization_user_file_id: string;
}

export interface AssignTrackToMultipleUserInput {
  organization_id?: number | null;
  track_id: number;
  user_list_ids: number[];
  centralized_user_list_ids?: number[] | null;
  send_email_to_all_selected_users?: boolean | null;
}

export interface AssignUserTeamCreationInput {
  organization_id?: number | null;
  success_file_id: number;
  organization_team_id: number;
  send_email_to_all_selected_users?: boolean | null;
}

export interface AutomationCustomizationInput {
  activation_dates: CustomizationActivationDateInput;
  automation_frequency: AutomationRuleFrequencyEnum;
  unsubscribe_users?: boolean | null;
  notify_users_via_email?: boolean | null;
}

export interface AutomationRuleAssignedContentTypeInput {
  rule_type: AutomationRuleTypeEnum;
  course_ids_list?: string[] | null;
  team_ids_list?: string[] | null;
  skill_xp_test_ids_list?: string[] | null;
}

/**
 * [Input] usage in update_automation_rule
 */
export interface AutomationRuleConfigurationsInput {
  settings: AutomationRuleSettingInput;
  segmentation_rules?: SegmentationRulesInput[] | null;
  customization_rules?: AutomationCustomizationInput | null;
  content_type: AutomationRuleAssignedContentTypeInput;
  users?: AutomationRuleEligibleUsersInput | null;
}

export interface AutomationRuleEligibleUsersInput {
  ids_in_rule_list?: string[] | null;
  ids_out_rule_list?: string[] | null;
  has_select_all?: boolean | null;
}

/**
 * [Query] get_automation_rule_by_admin
 */
export interface AutomationRuleGetInput {
  organization_id?: number | null;
  automation_rule_id: string;
}

/**
 * [Mutation] create_automation_rule
 */
export interface AutomationRuleInput {
  organization_id?: number | null;
  settings: AutomationRuleSettingInput;
  segmentation_rules?: SegmentationRulesInput[] | null;
  customization_rules?: AutomationCustomizationInput | null;
  content_type: AutomationRuleAssignedContentTypeInput;
  users?: AutomationRuleEligibleUsersInput | null;
}

export interface AutomationRuleSettingInput {
  user_creation_date_range?: UserCreationDateRangeInput | null;
  name: string;
  description?: string | null;
  is_paused?: boolean | null;
}

/**
 * [Mutation] update_automation_rule
 */
export interface AutomationRuleUpdateInput {
  organization_id?: number | null;
  automation_rule_id: string;
  automation_rule_configurations: AutomationRuleConfigurationsInput;
}

export interface CheckOrganizationHasDc3TemplateInput {
  organization_id: string;
}

export interface ContentOrganizationTeamCourseType {
  course_id: number;
  is_required: boolean;
  order: number;
}

export interface ContentOrganizationTeamInput {
  organization_id?: number | null;
  organization_team_id: number;
}

export interface CourseCreateInput {
  title?: string | null;
  level_id?: number | null;
}

export interface CourseFilterByInput {
  is_mandatory?: boolean | null;
  has_certification_available?: boolean | null;
  visibility_state?: StudioCourseConfigStateEnum | null;
}

/**
 * Input for course connection query [Admin].
 */
export interface CourseFilterInput {
  organization_id: string;
  order_by?: CourseInputOrderBy[] | null;
  page?: number | null;
  first: number;
  is_active?: boolean | null;
  is_draft?: boolean | null;
  search_key?: string | null;
  knowledge_hub_visibility?: VisibilityLevelType | null;
  filter_by?: CourseFilterByInput | null;
}

/**
 * Input for course detail query [Admin].
 */
export interface CourseGetInput {
  organization_id: string;
  course_id: string;
}

export interface CourseInputOrderBy {
  field: CourseOrderByEnum;
  direction: OrderDirectionEnum;
}

export interface CourseStudioCopyInput {
  course_id: string;
  organization_id: string;
  title: string;
  copy_course_type_enum: CopyCourseTypeEnum;
}

export interface CourseStudioCreateInput {
  course: CourseCreateInput;
  organization_id: string;
}

export interface CourseStudioDeleteInput {
  course_id: string;
  organization_id: string;
}

export interface CourseStudioTitleExistsInput {
  organization_id: string;
  title: string;
}

export interface CourseTeamDependenceRuleInput {
  course_id: string;
}

export interface CoursesAutomatedCreateOrGetTaskInput {
  name: string;
  company_id: number;
  task_type: TaskTypesEnum;
  object_id: number;
  description?: string | null;
  result_data?: string | null;
}

export interface CoursesByOrganizationTemplateTypeInput {
  organization_id: string;
  download_document_type_enum: DownloadDocumentTypeEnum;
  search_key?: string | null;
  first?: number | null;
  page?: number | null;
}

export interface CreateContentOrganizationTeamInput {
  name: string;
  description?: string | null;
  cover_image_id?: number | null;
  cover_image_url?: string | null;
  visibility_level?: VisibilityLevelType | null;
  categories?: string[] | null;
  start_date?: any | null;
  end_date?: any | null;
}

export interface CreateCustomFieldChoiceInput {
  name: any;
}

export interface CreateCustomFieldInput {
  name: any;
  description?: string | null;
  type: CustomFieldTypeEnum;
  can_edit: boolean;
  is_mandatory: boolean;
  is_visible: boolean;
  max_length?: number | null;
  where_mandatory?: CustomFieldMandatoryEnum | null;
  custom_field_choices?: CreateCustomFieldChoiceInput[] | null;
}

export interface CreateOrUpdateCourseTeamDependenceInput {
  course_id: string;
  depends_on: CourseTeamDependenceRuleInput[];
}

export interface CreateOrUpdateCourseTeamDependenceInputList {
  organization_team_id: string;
  is_active: boolean;
  courses_dependencies: CreateOrUpdateCourseTeamDependenceInput[];
}

export interface CreateOrganizationRewardInput {
  organization_id?: number | null;
  organization_team_id: string;
  number_courses: number;
}

export interface CreateOrganizationTeamInput {
  organization_team_id?: string | null;
  name: string;
  is_draft: boolean;
  start_date?: string | null;
  end_date?: string | null;
  user_ids: number[];
  user_organization_ids?: number[] | null;
  rules_data: OrganizationTeamRulesInput;
  reward_courses_number: number;
  organization_team_courses_list_ids: number[];
  articles_list_ids: number[];
  integrations_list_ids: number[];
}

export interface CreateTrackOrganizationTemplateInput {
  organization_id?: number | null;
  organization_template_id: number;
  track_id: number;
}

export interface CursorPaginationInput {
  first: number;
  after?: string | null;
}

export interface CustomEmailAttachmentInput {
  order: number;
  file_id: number;
  file_key: string;
  file_name: string;
}

export interface CustomFieldFilterInput {
  field_id: string;
  data_type: DataTypeEnum;
  values: string[];
}

export interface CustomFieldValuesInput {
  custom_field_id: string;
  values?: string[] | null;
}

export interface CustomizationActivationDateInput {
  start_datetime: any;
  end_datetime?: any | null;
}

export interface DC3OrganizationNamesInput {
  organization_id?: number | null;
  first?: number | null;
  after?: string | null;
  search?: SearchInput | null;
}

export interface DC3OrganizationTemplateData {
  enterprise_name?: string | null;
  enterprise_rfc?: string | null;
  enterprise_employer_registration?: string | null;
  enterprise_activity?: string | null;
  is_default_enterprise_data?: boolean | null;
  employee_curp_attribute_id: string;
  employee_curp_attribute_name: string;
  employee_occupation_stps_attribute_id: string;
  employee_occupation_stps_name: string;
  employee_job_attribute_id: string;
  employee_job_attribute_name: string;
  agent_name?: string | null;
  agent_type_enum?: AgentTypeEnum | null;
  agent_rfc?: string | null;
  agent_register_code_stps?: string | null;
  is_default_agent_data?: boolean | null;
  trainer_name?: string | null;
  trainer_register_code_stps?: string | null;
  is_default_trainer_data?: boolean | null;
  legal_representation_signature_name?: string | null;
  legal_representation_signature_file_id?: number | null;
  is_default_legal_manager_signature_data?: boolean | null;
  employer_representation_signature_name?: string | null;
  employer_representation_signature_file_id?: number | null;
  is_default_employer_representation_signature_data?: boolean | null;
  trainer_representation_signature_name?: string | null;
  trainer_representation_signature_file_id?: number | null;
  is_default_trainer_signature_data?: boolean | null;
  is_default_template_logo?: boolean | null;
  is_organization_name_automatic?: boolean | null;
  is_signatures_automatic?: boolean | null;
}

export interface DC3ThemeOptionTypeInput {
  search_key?: string | null;
  first?: number | null;
  page?: number | null;
}

export interface DC4OrganizationAttributeInput {
  organization_id: number;
  dc4_organization_attribute_id?: number | null;
  occupation_key?: string | null;
  occupation_key_name?: string | null;
  state_key?: string | null;
  state_key_name?: string | null;
  municipality_key?: string | null;
  municipality_key_name?: string | null;
  education_level_key?: string | null;
  education_level_key_name?: string | null;
  proof_document?: string | null;
  proof_document_name?: string | null;
  institution_key?: string | null;
  institution_key_name?: string | null;
  course_key?: string | null;
  course_key_name?: string | null;
  company_name_key?: string | null;
  company_name_key_name?: string | null;
  company_rfc_key?: string | null;
  company_rfc_key_name?: string | null;
  training_key?: string | null;
  training_key_name?: string | null;
  establishment_key?: string | null;
  establishment_key_name?: string | null;
}

export interface DeactivateUserTeamInput {
  organization_id?: number | null;
  success_file_id: number;
  organization_team_id: number;
}

export interface DeleteCourseInTeamOrganizationInput {
  organization_team_id: string;
  course_id: number;
}

export interface DeleteOrganizationCourseInstructorInput {
  organization_id?: number | null;
  organization_instructor_id: number;
}

export interface DeleteOrganizationTeamInput {
  organization_id: string;
  organization_team_id: string;
}

export interface DeleteOrganizationTemplateInput {
  organization_id?: number | null;
  organization_template_id: number;
}

export interface DeleteTrackOrganizationTemplateInput {
  organization_id?: number | null;
  track_organization_template_id: number;
}

export interface DeleteUserInTeamOrganizationInput {
  organization_team_id: string;
  user_id?: number | null;
  user_ids?: number[] | null;
}

export interface DownloadCertificateInput {
  download_document_type_enum: DownloadDocumentTypeEnum;
  organization_id: string;
  course_id?: string | null;
  user_id?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  user_attributes?: CustomFieldValuesInput[] | null;
  course_ids?: number[] | null;
  is_select_all_courses?: boolean | null;
}

export interface EmailValidationByExcel {
  organization_id?: number | null;
  file_id: number;
  action: ValidationEmailAction;
  organization_team_id?: string | null;
  course_id?: string | null;
  live_session_id?: string | null;
  send_email_to_all_selected_users?: boolean | null;
}

export interface EnrollmentRetrieveHistoryExcelInput {
  organization_id: number;
  course_id: number;
  action: ValidationEmailAction;
}

export interface FirstLevelAreaInput {
  area_id?: number | null;
  name: string;
  area_level_id: number;
  nodes?: SecondLevelAreaInput[] | null;
}

export interface FourthLevelAreaInput {
  area_id?: number | null;
  name: string;
  area_level_id: number;
}

export interface GetDC4OrganizationAttributeTypeInput {
  organization_id: number;
}

export interface GetOrganizationTemplateBaseInput {
  organization_template_base_id: string;
}

export interface GetOrganizationTemplateInput {
  organization_id?: number | null;
  organization_template_id: string;
}

export interface GetReportEnrollmentsByUserInput {
  learning_user_id?: number | null;
  learning_organization_id?: number | null;
  centralized_user_id?: number | null;
  centralized_organization_id?: number | null;
  order_by?: ReportEnrollmentInputOrderBy[] | null;
  filter_by?: ReportEnrollmentSearchFilterEnum | null;
  search_key?: string | null;
  before?: string | null;
  after?: string | null;
  first?: number | null;
  last?: number | null;
}

export interface GetReportTeamsByUserInput {
  learning_user_id?: number | null;
  learning_organization_id?: number | null;
  centralized_user_id?: number | null;
  centralized_organization_id?: number | null;
  order_by?: ReportTeamInputOrderBy[] | null;
  search_key?: string | null;
  before?: string | null;
  after?: string | null;
  first?: number | null;
  last?: number | null;
}

export interface GetSegmentedUsersInput {
  centralized_organization_id: number;
  segmentation: SegmentInput;
  pagination?: OffsetPaginationInput | null;
  filter?: SegmentFilterInput | null;
  order?: SegmentOrderInput[] | null;
  search?: string | null;
}

export interface GetTrackOrganizationTemplatesInput {
  organization_id?: number | null;
  track_id: string;
}

export interface LeaderboardReportInput {
  organization_id: string;
}

export interface ListValueSegmentationInput {
  id?: string | null;
  custom_field_id?: string | null;
  list_value?: string[] | null;
  is_active?: boolean | null;
}

/**
 * Input for retrieve a live session resource [Query]
 */
export interface LiveSessionGetResourceInput {
  organization_id?: number | null;
  live_session_id: string;
}

export interface MassiveAssignmentInput {
  user_assignment_id: string;
}

export interface MassiveAttendanceInput {
  user_attendance_id: string;
  register_candidates: boolean;
}

/**
 * Input used in massive_users_engagement [Mutation]
 */
export interface MassiveSessionUserEngagementInput {
  organization_id?: number | null;
  live_session_id: string;
  assignment?: MassiveAssignmentInput | null;
  attendance?: MassiveAttendanceInput | null;
}

export interface NavigationDataInput {
  slug: string;
  pagination?: CursorPaginationInput | null;
  search?: NavigationDataSearchInput | null;
}

export interface NavigationDataSearchInput {
  search?: string | null;
}

export interface OffsetPaginationInput {
  page?: number | null;
  page_size?: number | null;
}

export interface OrganizationBaseInput {
  organization_id?: number | null;
}

export interface OrganizationCourseInstructorData {
  organization_id: number;
  organization_instructor_id?: string | null;
  agent_type_enum: AgentTypeEnum;
  organization_name_id?: string | null;
  name: string;
  rfc?: string | null;
  code_stps?: string | null;
  code_dc5?: string | null;
  signature_name?: string | null;
  signature_file_id?: number | null;
  theme_option_ids?: string[] | null;
}

export interface OrganizationCourseInstructorInput {
  organization_instructor: OrganizationCourseInstructorData;
}

export interface OrganizationCourseInstructorsInput {
  organization_id?: number | null;
  first?: number | null;
  after?: string | null;
  search?: SearchInput | null;
  agent_type_enum?: AgentTypeEnum | null;
}

export interface OrganizationCoursesInput {
  organization_id?: number | null;
}

export interface OrganizationTeamCourseInput {
  course_id: number;
  order: number;
}

export interface OrganizationTeamCourseInputList {
  organization_id: number;
  organization_team_id: number;
  courses: OrganizationTeamCourseInput[];
}

export interface OrganizationTeamRulesInput {
  courses_to_certificate: number;
  courses_to_complete: number;
}

export interface OrganizationTemplateData {
  organization_id: string;
  organization_template_id?: string | null;
  template_type_enum?: TemplateTypeEnum | null;
  template_regulation_type_enum?: TemplateRegulationTypeEnum | null;
  is_default?: boolean | null;
  html_content?: string | null;
  template_name?: string | null;
  sort_order?: number | null;
  status_enum?: TemplateStatusEnum | null;
  background_image_file_id?: number | null;
  json_editor_configuration?: any | null;
  orientation_enum?: TemplateOrientationEnum | null;
  json_extra_fields?: any | null;
}

export interface OrganizationTemplateInput {
  organization_template: OrganizationTemplateData;
  dc3_organization_template_data?: DC3OrganizationTemplateData | null;
  organization_template_logos?: OrganizationTemplateLogoData[] | null;
}

export interface OrganizationTemplateLogoData {
  sort_order?: number | null;
  logo_file_id?: number | null;
  element_identifier?: string | null;
}

export interface OrganizationTemplatesInput {
  organization_id?: number | null;
  search_text?: string | null;
  template_type_enum?: TemplateTypeEnum | null;
  template_regulation_type_enum?: TemplateRegulationTypeEnum | null;
  status_enum?: TemplateStatusEnum | null;
}

export interface PeriodDate {
  from_date?: any | null;
  to_date?: any | null;
}

export interface PermissionInput {
  id: number;
  can_view: boolean;
  can_edit: boolean;
}

export interface PersonalizationInput {
  organization_id: number;
  logo?: string | null;
  image_login?: string | null;
  favicon?: string | null;
  file_image_login_id?: number | null;
  file_favicon_id?: number | null;
  file_logo_id?: number | null;
}

export interface QueryAllowedUserInput {
  organization_id: string;
  limit?: number | null;
  offset?: number | null;
}

/**
 * Input for delete a live session [Mutation]
 */
export interface QuizAddAttemptInput {
  organization_id?: number | null;
  user_id: string;
  course_id: string;
}

export interface ReportCustomFieldInput {
  field_id: string;
  field_answers: string[];
}

export interface ReportEnrollmentInputOrderBy {
  field: ReportEnrollmentOrderByEnum;
  direction: OrderDirectionEnum;
}

export interface ReportInputNode {
  slug: string;
  report_type: ReportsEnum;
  start_date?: any | null;
  end_date?: any | null;
  user_status?: (AnalyticsUserStatusEnum | null)[] | null;
  user_role?: (UserRoleEnum | null)[] | null;
  file_format?: FileFormatEnum | null;
  custom_fields?: (ReportCustomFieldInput | null)[] | null;
  routes?: (number | null)[] | null;
  courses?: (number | null)[] | null;
  name?: string | null;
  description?: string | null;
  direct_download?: boolean | null;
  user_id?: number | null;
  org_id?: number | null;
  course_enroll_status?: boolean | null;
  report_id?: number | null;
  sheets?: (GeneralSheetsEnum | null)[] | null;
  activity_end_date?: any | null;
  activity_start_date?: any | null;
  generation_type?: ReportGenerationTypeEnum | null;
  generation_frequency?: OrganizationReportGenerationFrequencyEnum | null;
  users_ids?: number[] | null;
  team_id?: string | null;
  is_crehana_course?: boolean | null;
  has_course_completed?: boolean | null;
  quiz_status?: (QuizStatusEnum | null)[] | null;
  has_certificated?: boolean | null;
}

export interface ReportTeamInputOrderBy {
  field: ReportTeamOrderByEnum;
  direction: OrderDirectionEnum;
}

export interface SearchInput {
  query?: string | null;
}

export interface SecondLevelAreaInput {
  area_id?: number | null;
  name: string;
  area_level_id: number;
  nodes?: ThirdLevelAreaInput[] | null;
}

export interface SegmentFilterInput {
  positions?: number[] | null;
  areas?: number[] | null;
}

export interface SegmentInput {
  global_modifier: SegmentGlobalModifier;
  type: SegmentTypeEnum;
  rules: SegmentRuleInput[];
}

export interface SegmentOrderInput {
  field: OrderUserAttributeEnum;
  desc: boolean;
}

export interface SegmentRuleAlphabeticInput {
  alphabetic_literal_attribute?: SegmentRuleAlphabeticAttributeLiteralEnum | null;
  custom_field_attribute_id?: number | null;
  alphabetic_multiple_operator?: SegmentRuleAlphabeticConditionMultipleEnum | null;
  alphabetic_multiple_operand?: string[] | null;
  alphabetic_single_operator?: SegmentRuleAlphabeticConditionSingleEnum | null;
  alphabetic_single_operand?: string | null;
}

export interface SegmentRuleAreaInput {
  area_ids: number[];
}

export interface SegmentRuleDateInput {
  date_literal_attribute?: SegmentRuleDateAttributeLiteralEnum | null;
  custom_field_attribute_id?: number | null;
  date_range_operator?: SegmentRuleDateConditionRangeEnum | null;
  date_range_operand?: any[] | null;
  date_single_operator?: SegmentRuleDateConditionSingleEnum | null;
  date_single_operand?: any | null;
}

export interface SegmentRuleInput {
  alphabetic_rule?: SegmentRuleAlphabeticInput | null;
  numeric_rule?: SegmentRuleNumericInput | null;
  date_rule?: SegmentRuleDateInput | null;
  area_rule?: SegmentRuleAreaInput | null;
}

export interface SegmentRuleNumericInput {
  custom_field_attribute_id?: number | null;
  numeric_range_operator?: SegmentRuleNumericConditionRangeEnum | null;
  numeric_range_operand?: number[] | null;
  numeric_single_operator?: SegmentRuleNumericConditionSingleEnum | null;
  numeric_single_operand?: number | null;
}

export interface SegmentationRulesInput {
  text_value_condition?: TextValueSegmentationInput | null;
  list_value_condition?: ListValueSegmentationInput | null;
  conditional_type: AutomationConditionalTypesEnum;
}

export interface SegmentedUsersListInput {
  organization_id?: number | null;
  automation_rule_id?: string | null;
  user_creation_date_range?: UserCreationDateRangeInput | null;
  segmentation_rules?: SegmentationRulesInput[] | null;
  user_filters?: UserFiltersInput | null;
  first?: number | null;
  page?: number | null;
}

export interface SendCustomEmailBaseInput {
  organization_id?: number | null;
  custom_template_identifier: string;
  section?: EmailSectionEnum | null;
  content_type?: EmailContentTypeEnum | null;
  content_value?: string | null;
  attachments?: CustomEmailAttachmentInput[] | null;
  subject?: string | null;
  body?: string | null;
  banner_file_id?: number | null;
  centralized_organization_id?: number | null;
}

export interface SendCustomEmailToUsersInput {
  organization_id?: number | null;
  custom_template_identifier: string;
  section?: EmailSectionEnum | null;
  content_type?: EmailContentTypeEnum | null;
  content_value?: string | null;
  attachments?: CustomEmailAttachmentInput[] | null;
  subject?: string | null;
  body?: string | null;
  banner_file_id?: number | null;
  centralized_organization_id?: number | null;
  user_ids?: number[] | null;
  user_ids_out?: number[] | null;
  has_select_all?: boolean | null;
}

/**
 * Input used in session_user_engagement [Mutation]
 */
export interface SessionUserEngagementInput {
  organization_id?: number | null;
  live_session_id: string;
  validation_type: LiveSessionUserTrackerTypeEnum;
  manual_data?: SessionUserManualInput | null;
  massive_data?: SessionUserMassiveInput | null;
}

export interface SessionUserManualInput {
  users_id_list?: string[] | null;
  selected_all?: boolean | null;
}

export interface SessionUserMassiveInput {
  file_url: string;
  file_id: string;
  extra_data?: string | null;
}

export interface TextValueSegmentationInput {
  id?: string | null;
  custom_field_id?: string | null;
  text_value?: string | null;
  is_active?: boolean | null;
}

export interface ThirdLevelAreaInput {
  area_id?: number | null;
  name: string;
  area_level_id: number;
  nodes?: FourthLevelAreaInput[] | null;
}

export interface UpdateConfigurationAreaInput {
  id: number;
  name?: string | null;
  is_active?: boolean | null;
}

export interface UpdateConfigurationHeadquarterInput {
  id?: number | null;
  is_main?: boolean | null;
  is_active_all?: boolean | null;
}

export interface UpdateContentOrganizationTeamInput {
  organization_team_id: number;
  organization_team_courses?: ContentOrganizationTeamCourseType[] | null;
  expiration_time_in_days?: number | null;
  is_draft?: boolean | null;
  rewards_numbers?: number | null;
  courses_dependencies?: CreateOrUpdateCourseTeamDependenceInput[] | null;
  is_active_course_dependencies?: boolean | null;
  name?: string | null;
  description?: string | null;
  cover_image_id?: number | null;
  cover_image_url?: string | null;
  visibility_level?: VisibilityLevelType | null;
  categories?: string[] | null;
  start_date?: any | null;
  end_date?: any | null;
  generate_certificate?: boolean | null;
}

export interface UpdateDefaultOrganizationTemplateInput {
  organization_id?: number | null;
  organization_template_id: number;
  is_default: boolean;
}

export interface UpdateOrganization {
  name?: string | null;
  phone?: string | null;
  organization_id: number;
  industry_id?: number | null;
}

export interface UpdateStatusInputs {
  organization_id?: number | null;
  company_id?: number | null;
  centralized_id?: number | null;
  centralized_organization_id?: string | null;
  file_id: number;
  new_status: FileStorageStatusEnum;
  size?: number | null;
}

export interface UpdateTrackOrganizationTemplateInput {
  organization_id?: number | null;
  track_organization_template_id?: number | null;
  organization_template_id: number;
  track_id: number;
}

export interface UploadFilePreSignedURLInput {
  organization_id?: number | null;
  company_id?: number | null;
  centralized_id?: number | null;
  centralized_organization_id?: string | null;
  filename: string;
  content_type: string;
  filepath?: string | null;
  bucket: BucketsEnum;
}

export interface UserActivationInput {
  organization_slug: string;
  users_ids: number[];
}

export interface UserCreationDateRangeInput {
  start_datetime?: any | null;
  end_datetime?: any | null;
}

export interface UserFilterByInput {
  search_text?: string | null;
  tags: string[];
}

export interface UserFiltersInput {
  text?: string | null;
  user_type?: AutomationUserTypeEnum | null;
}

export interface UserRecoverPasswordInput {
  organization_slug: string;
  user_id: number;
  next_url?: string | null;
}

export interface UsersForLeaderboardInput {
  organization_id: string;
  first: number;
  page: number;
  filter_by: UserFilterByInput;
}

export interface UsersUploadUrl {
  filename: string;
  organization_slug: string;
  file_upload?: string | null;
}

export interface ValidateUserTeamAssignmentInput {
  organization_id?: number | null;
  organization_team_id: string;
  file_id: number;
  action?: ActionType | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
